<template>
  <div @click="$emit('input', id)" :class="[active, 'tab']">
    {{ label }}
  </div>
</template>

<script>
export default {
  props: {
    id: Number,
    label: String,
    value: Number
  },
  computed: {
    active () {
      return this.value === this.id ? 'active' : false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/renewal/components/Qna-Item.vue